import { render, staticRenderFns } from "./DefaultRoute.vue?vue&type=template&id=3fc919c2&scoped=true"
import script from "./DefaultRoute.vue?vue&type=script&lang=ts"
export * from "./DefaultRoute.vue?vue&type=script&lang=ts"
import style0 from "./DefaultRoute.vue?vue&type=style&index=0&id=3fc919c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc919c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fc919c2')) {
      api.createRecord('3fc919c2', component.options)
    } else {
      api.reload('3fc919c2', component.options)
    }
    module.hot.accept("./DefaultRoute.vue?vue&type=template&id=3fc919c2&scoped=true", function () {
      api.rerender('3fc919c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DefaultRoute.vue"
export default component.exports